/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors } from "../styles"

export const LogoMaster = ({ color, ...restProps }) => (
  <svg
    css={{
      minWidth: "2rem",
    }}
    {...restProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 359.1 353.82"
  >
    <title>Logo Master</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_3" data-name="Layer 3">
        <g css={{ fill: "white" }}>
          {/* "MP" */}
          <circle class="cls-1" cx="178.99" cy="117.14" r="106.75" />
        </g>
        <g css={{ fill: color || colors.BLUE }}>
          {/* BACKGROUND SHAPES */}
          <path
            class="cls-2"
            d="M218.76,119.45h19.55a29.37,29.37,0,0,0,11.8-2.18c6.66-3,10.59-9.63,10.59-18.86,0-8.42-3.39-14.8-9.36-17.92a21.39,21.39,0,0,0-9.5-2.31h0c-5.71-1-24.3-.81-27-.81H208l2.17,42.08Z"
          />
          <path
            class="cls-2"
            d="M93.61,159.62h13.17l6.65-82.25H100V65.83h29.86l27,64.2a49.28,49.28,0,0,1,2.3,7.6h.41A72.35,72.35,0,0,1,162,130l27.15-64.2h50.76A45.5,45.5,0,0,1,258,68.68c10.86,4.62,17.91,15.88,17.91,29.86,0,14.8-7.73,26.74-19.81,31a48.54,48.54,0,0,1-15.88,2.31H210.89l1.36,28h13v11.67H184.69V159.76h12.76l-3.66-48c-.82-9.37-1.36-16.15-1.77-21-.54,1.9-1.09,3.67-1.76,5.57L166.1,151.62H152.93L128.77,96.1a50.45,50.45,0,0,1-2-6.38l-.4,5.43v1.63l-1.77,22.53-3,40.31h12.76V171.3H93.61ZM179,234.28A117.14,117.14,0,1,0,61.85,117.14,117.17,117.17,0,0,0,179,234.28h0"
          />
        </g>

        <g css={{ fill: color || colors.BLUE }}>
          {/* "MYSTIC PARKER PRINTING" */}
          <path
            class="cls-2"
            d="M0,284.49H4.93l2.52-30.85h-5v-4.31h11.2l10.13,24.08a23.39,23.39,0,0,1,.9,2.85h.11a23.39,23.39,0,0,1,.9-2.85l10.13-24.08H47v4.31h-5l2.52,30.85h4.93v4.37H34.16v-4.37h4.76l-1.79-23.63a26.19,26.19,0,0,1,.17-3.25h-.17a27.23,27.23,0,0,1-.9,3l-9.07,20.77H22.23l-9.07-20.77a27.23,27.23,0,0,1-.9-3H12.1a27,27,0,0,1,.16,3.25l-1.79,23.63h4.76v4.37H0Z"
          />
          <path
            class="cls-2"
            d="M56.15,296.09c2.41,0,4.26-1.68,5.21-3.92l1.17-2.8-9.91-24.64H49v-4.2H62v4.2H58.22l6.33,16.85a13.12,13.12,0,0,1,.5,2.47h.17a18.2,18.2,0,0,1,.67-2.47l6.28-16.85H68.53v-4.2H81.07v4.2H77.54l-11.2,28.61c-1.9,4.82-5.6,7.28-10,7.28a11.18,11.18,0,0,1-6.1-1.79l1.85-4.09A6.78,6.78,0,0,0,56.15,296.09Z"
          />
          <path
            class="cls-2"
            d="M83.25,279.73H88v1.85c0,2.41,3.36,3.53,6.5,3.53s5.71-1.29,5.71-3.64c0-2.86-3.13-3.75-7-5.15-4.2-1.57-8.85-3.47-8.85-8.63,0-5.6,5.54-7.84,10.47-7.84,4,0,9.8,1.57,9.8,5.72V269H99.83v-1.85c0-1.73-2.24-2.91-5-2.91s-5,1.12-5,3.42c0,2.69,3.13,3.81,6.55,5,4.37,1.46,9.35,3.31,9.35,8.57s-4.93,8.34-11.37,8.34c-5.15,0-11.09-2.29-11.09-6.77Z"
          />
          <path
            class="cls-2"
            d="M113,264.73h-4.76v-4.2h4.87v-7.79h5.33v7.79h6.77v4.2h-6.77V278c0,5.77,3.92,6.49,6,6.49.79,0,1.29-.05,1.29-.05V289a14.24,14.24,0,0,1-2,.12C120.2,289.09,113,288,113,278.5Z"
          />
          <path
            class="cls-2"
            d="M129.34,284.66h4.43V264.73h-4.71v-4.2H139.2v24.13h4.48v4.2H129.34Zm4.31-35.33h5.72v5.54h-5.72Z"
          />
          <path
            class="cls-2"
            d="M161,259.85c4.2,0,11.09,1.57,11.09,6.44v3.48h-4.81v-2c0-2.19-3.59-3.25-6.11-3.25-5.71,0-9.63,4-9.63,10.08,0,6.44,4.53,10.19,10,10.19a14.42,14.42,0,0,0,9.07-3.64l2.07,4a17.3,17.3,0,0,1-11.37,4.36c-8.17,0-15.28-5.65-15.28-14.78A14.57,14.57,0,0,1,161,259.85Z"
          />
          <path
            class="cls-2"
            d="M191.64,284.49h4.93V253.64h-4.93v-4.31h18.42a16.54,16.54,0,0,1,6.78,1.06c4.09,1.74,6.72,5.94,6.72,11.2,0,5.54-2.91,10-7.45,11.59a17,17,0,0,1-5.93.84h-8v10.47h5v4.37H191.64Zm17.86-15.06a11.45,11.45,0,0,0,4.43-.78c2.52-1.12,4-3.64,4-7.06,0-3.19-1.28-5.54-3.52-6.72a10.33,10.33,0,0,0-4.82-1h-7.39v15.51Z"
          />
          <path
            class="cls-2"
            d="M242.52,271.45h1.79v-1.07c0-4.48-2.57-6.05-6-6.05a15.05,15.05,0,0,0-8.12,2.75L228,263.21a18.22,18.22,0,0,1,10.75-3.36c7.23,0,11,3.76,11,10.92v12.66a1.09,1.09,0,0,0,1.23,1.23h2.85v4.2h-5.65c-2.52,0-3.53-1.23-3.53-3.08v-.39a7,7,0,0,1,.22-1.85h-.11a10.29,10.29,0,0,1-9.35,6c-4.7,0-9.41-2.74-9.41-8.56C226,272.06,237.82,271.45,242.52,271.45Zm-5.93,13.88c4.81,0,7.78-4.92,7.78-9.18V275H243c-2.58,0-11.48.12-11.48,5.55A4.78,4.78,0,0,0,236.59,285.33Z"
          />
          <path
            class="cls-2"
            d="M257.41,284.66h4.26V266a1.1,1.1,0,0,0-1.23-1.23h-3.53v-4.2h6.38c2.47,0,3.64,1,3.64,3.3v1.79a16.75,16.75,0,0,1-.11,2h.11c1.29-4.14,4.59-7.39,9-7.39a9.77,9.77,0,0,1,1.4.11v5.38a7.06,7.06,0,0,0-1.57-.17c-6,0-8.62,6.1-8.62,11.65v7.5h4.2v4.2H257.41Z"
          />
          <path
            class="cls-2"
            d="M277.79,284.66h4.48V253.53h-4.76v-4.2h10.14v22.06h4.14l5.66-6.66h-3.7v-4.2h12.88v4.2h-3.75l-7,8.17V273c.05,0,.95.4,2.07,2.3l4.82,8.23c.56.9,1,1.12,2.46,1.12H307v4.2h-4.25c-2.58,0-3.42-.45-4.65-2.63l-5.6-9.58c-.62-1-1.4-1.12-2.63-1.12h-2.24v9.13h3.8v4.2H277.79Z"
          />
          <path
            class="cls-2"
            d="M323.15,259.85c8.06,0,12.26,5.94,12.26,13.28,0,.72-.16,2.07-.16,2.07H314.53c.33,6.27,4.76,9.63,9.8,9.63a13.8,13.8,0,0,0,8.45-3.19l2.24,4a17.34,17.34,0,0,1-11,3.92c-8.9,0-15-6.44-15-14.84C309,265.68,315.09,259.85,323.15,259.85Zm6.66,11.88c-.16-5-3.19-7.56-6.77-7.56-4.15,0-7.51,2.8-8.29,7.56Z"
          />
          <path
            class="cls-2"
            d="M339.22,284.66h4.26V266a1.1,1.1,0,0,0-1.23-1.23h-3.53v-4.2h6.38c2.46,0,3.64,1,3.64,3.3v1.79a16.75,16.75,0,0,1-.11,2h.11c1.29-4.14,4.59-7.39,9-7.39a9.77,9.77,0,0,1,1.4.11v5.38a7.06,7.06,0,0,0-1.57-.17c-6,0-8.62,6.1-8.62,11.65v7.5h4.2v4.2H339.22Z"
          />
          <path
            class="cls-2"
            d="M70.16,337.69h4.93V306.84H70.16v-4.31H88.58a16.54,16.54,0,0,1,6.78,1.06c4.09,1.74,6.72,5.94,6.72,11.2,0,5.54-2.91,10-7.45,11.59a17,17,0,0,1-5.94.84h-8v10.47h5v4.37H70.16ZM88,322.63a11.52,11.52,0,0,0,4.43-.78c2.52-1.12,4-3.64,4-7.06,0-3.19-1.29-5.54-3.53-6.72a10.26,10.26,0,0,0-4.81-.95H80.69v15.51Z"
          />
          <path
            class="cls-2"
            d="M106.28,337.86h4.26v-18.7a1.1,1.1,0,0,0-1.23-1.23h-3.53v-4.2h6.38c2.47,0,3.64,1,3.64,3.3v1.79a16.75,16.75,0,0,1-.11,2h.11c1.29-4.14,4.6-7.39,9-7.39a9.77,9.77,0,0,1,1.4.11v5.38a7,7,0,0,0-1.56-.17c-6,0-8.63,6.1-8.63,11.65v7.5h4.2v4.2H106.28Z"
          />
          <path
            class="cls-2"
            d="M129.63,337.86h4.42V317.93h-4.7v-4.2h10.14v24.13H144v4.2H129.63Zm4.31-35.33h5.71v5.54h-5.71Z"
          />
          <path
            class="cls-2"
            d="M147.65,337.86h4.42v-18.7a1.1,1.1,0,0,0-1.23-1.23h-3.47v-4.2h6.38c2.46,0,3.58,1.06,3.58,3.13v1.46a8.44,8.44,0,0,1-.16,1.62h.11a11.92,11.92,0,0,1,11-6.89c6.49,0,9.41,3.64,9.41,10.87v13.94h4.48v4.2h-9.91V325.15c0-4-.79-7.11-5.33-7.11-5.71,0-9.46,5.21-9.46,10.86v9H162v4.2H147.65Z"
          />
          <path
            class="cls-2"
            d="M187,317.93h-4.76v-4.2h4.87v-7.79h5.32v7.79h6.78v4.2h-6.78V331.2c0,5.77,3.92,6.49,6.05,6.49.79,0,1.29-.05,1.29-.05v4.53a14.24,14.24,0,0,1-2,.12c-3.58,0-10.81-1.12-10.81-10.59Z"
          />
          <path
            class="cls-2"
            d="M203.38,337.86h4.42V317.93h-4.7v-4.2h10.14v24.13h4.48v4.2H203.38Zm4.31-35.33h5.71v5.54h-5.71Z"
          />
          <path
            class="cls-2"
            d="M221.4,337.86h4.42v-18.7a1.1,1.1,0,0,0-1.23-1.23h-3.47v-4.2h6.38c2.46,0,3.58,1.06,3.58,3.13v1.46a8.44,8.44,0,0,1-.16,1.62H231a11.92,11.92,0,0,1,11-6.89c6.5,0,9.41,3.64,9.41,10.87v13.94H256v4.2H246V325.15c0-4-.79-7.11-5.32-7.11-5.72,0-9.47,5.21-9.47,10.86v9h4.48v4.2H221.4Z"
          />
          <path
            class="cls-2"
            d="M270.29,349.23c4.93,0,9-2.24,9-8.06v-2.24a11.12,11.12,0,0,1,.17-1.8h-.11a9.24,9.24,0,0,1-8.51,4.6c-7.84,0-12.66-6.33-12.66-14.51s4.54-14.17,12.43-14.17c3.7,0,7.62,1.4,9.19,4.65h.11a4.55,4.55,0,0,1-.11-1.12c0-1.79.89-2.85,3.25-2.85h6v4.2h-3.13a1.09,1.09,0,0,0-1.23,1.12v21.84c0,9.35-7.12,12.93-14.28,12.93a22.27,22.27,0,0,1-9.69-2.35l1.79-4.14A18.29,18.29,0,0,0,270.29,349.23Zm9.08-22c0-7.39-3.59-9.52-8-9.52-4.87,0-7.67,3.58-7.67,9.35s3.08,9.91,8.17,9.91C275.78,337,279.37,334.67,279.37,327.28Z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default LogoMaster
